import {
    GET_MY_TASKS_REQUEST,
    GET_MY_TASKS_SUCCESS,
    GET_MY_TASKS_FAIL,
    MARK_TASK_COMPLETED_SUCCESS
} from '../actions/taskActions';

const initialState = {
    tasks: [],
    loading: false,
    error: null
};

const taskReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MY_TASKS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_MY_TASKS_SUCCESS:
            return { ...state, loading: false, tasks: action.payload };
        case GET_MY_TASKS_FAIL:
            return { ...state, loading: false, error: action.error };
        case MARK_TASK_COMPLETED_SUCCESS:
            return {
                ...state,
                // Keep the task in the list so it remains available in the
                // "Terminées" tab and can contribute to progress indicators.
                tasks: state.tasks.map(task =>
                    task.id === action.payload.taskId
                        ? { ...task, status: 'COMPLETED', completedAt: new Date().toISOString() }
                        : task
                )
            };
        default:
            return state;
    }
};

export default taskReducer;
